import React, { createContext, useState, useEffect, useContext } from 'react';
import * as api from '../services/api';

const LegalContext = createContext();

export const LegalProvider = ({ children }) => {
    const [documents, setDocuments] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchDocuments = async () => {
        setLoading(true);
        try {
            const docs = await api.getLegalDocuments();
            setDocuments(docs || []);
        } catch (error) {
            console.error("Failed to load legal documents:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchDocuments();
    }, []);

    const createDocument = async (docData) => {
        try {
            const newDoc = await api.createLegalDocument(docData);
            setDocuments(prev => [...prev, newDoc]);
            return newDoc;
        } catch (error) {
            console.error("Failed to create document:", error);
            throw error;
        }
    };

    const updateDocument = async (id, docData) => {
        try {
            const updated = await api.updateLegalDocument(id, docData);
            setDocuments(prev => prev.map(d => d.id === id ? updated : d));
            return updated;
        } catch (error) {
            console.error("Failed to update document:", error);
            throw error;
        }
    };

    const deleteDocument = async (id) => {
        try {
            await api.deleteLegalDocument(id);
            setDocuments(prev => prev.filter(d => d.id !== id));
        } catch (error) {
            console.error("Failed to delete document:", error);
            throw error;
        }
    };

    return (
        <LegalContext.Provider value={{
            documents,
            loading,
            createDocument,
            updateDocument,
            deleteDocument,
            refreshDocuments: fetchDocuments
        }}>
            {children}
        </LegalContext.Provider>
    );
};

export const useLegal = () => useContext(LegalContext);
